// @flow

import React, { Fragment } from 'react';
import { Spacer } from '@zapier/design-system';
import help from 'app/developer-v3/components/PartnerSupportForm/components/blocks/Help';
import { ZAPIER_APP_BASE_URL } from 'app/common/constants';
import { NEW_EXPERTS_BASE_URL } from 'app/developer-v3/constants';

export const createBecomeSolutionPartner = () => ({
  value: 'become-solution-partner',
  label: 'I want to become a Solution Partner',
  child: help({
    docs: {
      title: 'Zapier Solution Partner Program',
      body: () => (
        <Fragment>
          <p>
            Thank you for your interest in becoming a Zapier Solution Partner!
            Please visit{' '}
            <a
              href="https://share.hsforms.com/1BVFH0zJTQ86GHcButJfjKw4fxs5"
              rel="noopener noreferrer"
              target="_blank"
            >
              this link to apply
            </a>
            . After applying, we highly recommend checking out for skills
            training and reading about the work our existing Solution Partners
            are doing with users by visiting the links below.
          </p>
        </Fragment>
      ),
      links: [
        {
          href: `https://learn.zapier.com/`,
          title: 'Zapier Learn',
        },
        {
          href: `${ZAPIER_APP_BASE_URL}/partnerdirectory`,
          title: 'Zapier Solution Partner Directory',
        },
      ],
    },
  }),
});

export const createReferralProgram = () => ({
  value: 'referral-program',
  label: 'How does the referral program work?',
  child: help({
    docs: {
      title: 'Zapier Referral Program',
      body: () => (
        <Fragment>
          <p>
            The Zapier Referral Program rewards Solution Partners who introduce
            net-new customers to Zapier. Whether you're working with startups,
            enterprises, or automation-first teams, you can earn commissions
            when your referred clients subscribe to a paid Zapier plan. The
            Referral Program is currently only available to Solution Partners.
          </p>
        </Fragment>
      ),
      links: [
        {
          href: `${NEW_EXPERTS_BASE_URL}/l/solution-partner/`,
          title: 'Become a Zapier Solution Partner',
        },
      ],
    },
  }),
});

export const createCreatorAffiliate = () => ({
  value: 'reseller-affiliate',
  label: 'Creator program and affiliate opportunities',
  child: help({
    docs: {
      title: 'Creator program and affiliate opportunities',
      body: () => (
        <Fragment>
          <p>
            If you create content on platforms such as YouTube, Instagram,
            LinkedIn, or TikTok, and would like to earn commissions through an
            affiliate program, please visit{' '}
            <a
              href="https://dash.partnerstack.com/application?company=zapier&group=ambassadorbasepay"
              rel="noopener noreferrer"
              target="_blank"
            >
              this link to apply
            </a>
            .
          </p>
          <Spacer height={16} />
          <p>At this time, we do not have a reseller program in place.</p>
        </Fragment>
      ),
    },
  }),
});
